import {
  faKey,
  faLifeRing,
  faLock,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons';
import { SessionManager } from '@shared/app/scripts/services/session-manager';
import { Component, Output } from 'angular-ts-decorators';

/**
 * # loginWidget
 * General widget to display login widget.
 *
 * ## Usage example
 * <pre>
 *   <login-widget success="action(payload)"></login-widget>
 * </pre>
 */
@Component({
  selector: 'loginWidget',
  template: require('./login-widget.html').default,
})
export class LoginWidgetComponent {
  @Output() success: ({ payload }: { payload: any }) => void;

  public lockIcon: IconDefinition = faLock;
  public keyIcon: IconDefinition = faKey;
  public lifeRingIcon: IconDefinition = faLifeRing;

  public message: string = '';
  public error: string = '';
  public password: string = '';
  public authenticationToken: string = '';
  public twoFactorAuthenticationCode: string = '';

  constructor(
    private $translate: ng.translate.ITranslateService,
    private sessionManager: SessionManager,
  ) {
    'ngInject';
  }

  public escape(value: string): string {
    if (angular.isUndefined(value) || value === null) {
      value = '';
    }

    return encodeURIComponent(value);
  }

  public submitUsernamePassword(
    username: string,
    password: string,
    rememberMe: boolean,
  ): ng.IPromise<any> {
    let loginPromise;

    this.error = undefined;
    this.message = this.$translate.instant('core.please_wait');

    loginPromise = this.sessionManager.login(username, password, rememberMe);

    loginPromise.then(
      (payload) => {
        if (payload['2FAToken']) {
          this.message = '';
          this.authenticationToken = payload['2FAToken'];
        } else {
          this.message = this.$translate.instant('core.login_succeeded');
          if (angular.isFunction(this.success)) {
            this.success({ payload });
          }
        }
      },
      (error) => {
        this.message = undefined;
        this.error = error;
        this.password = '';
      },
    );

    return loginPromise;
  }

  public submitAuthenticationToken(token, code) {
    this.error = undefined;
    this.message = this.$translate.instant('core.please_wait');

    const twoFaPromise = this.sessionManager.loginTwoFa(token, code);

    twoFaPromise.then(
      (payload) => {
        this.message = this.$translate.instant('core.login_succeeded');
        if (angular.isFunction(this.success)) {
          this.success({ payload: payload });
        }
      },
      (error) => {
        this.message = undefined;
        this.error = error;
        this.twoFactorAuthenticationCode = '';
      },
    );

    return twoFaPromise;
  }
}
